module.exports = "div.contenedor{display:block;width:100%}div.contenedor>div{display:inline-block;width:50%}div.contenedor>div.right{text-align:right}\n"